import { render, staticRenderFns } from "./NewPropertyRecord.vue?vue&type=template&id=330d9969"
import script from "./NewPropertyRecord.vue?vue&type=script&lang=js"
export * from "./NewPropertyRecord.vue?vue&type=script&lang=js"
import style0 from "./NewPropertyRecord.vue?vue&type=style&index=0&id=330d9969&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports